WL.DocumentPrintRepeater = new Class({

    Extends: TS.domain.RepeaterEditDomain,

    hookDocument: function () {
        var me = this,
            cmd_ViewPrint,
            owner = me.ParentDomain;

        cmd_ViewPrint = me.getCommand('ViewPrint');
        cmd_ViewPrint.Text(me.Document().TemplateName());
        cmd_ViewPrint.Enabled(me.Document().HasContent());
        cmd_ViewPrint.Visible(me.Document().HasContent());

        me.HasNoContent = ko.computed(function () {
            if (me.Document().HasContent() == false)
                return true;
            else return false;
        });
    },

    createCommands: function (config) {
        var me = this;

        me.parent(config);

        me.createCommandCategory('Custom', config);
        var cat = me.CommandCategories.Custom.Commands || { commands: [] };

        // add new command
        newCmd = new TS.domain.Command();
        newCmd['Code'] = 'ViewPrint';
        newCmd['handler'] = '_viewPrint';
        cat.push(newCmd);
    },

    _viewPrint: function () {
        var me = this,
            owner = me.ParentDomain;

        // instruct parent model to perform command
        owner.performServerCommand('ViewPrint', true, { DocumentUID: me.Document().UID() });
    }

});